package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_ANALYTICS_ENABLED = "analytics_enabled"

/**
 * Analytics sharing is no longer a user-facing toggle -- it's always on. [isEnabled] is
 * hardcoded rather than reading [KEY_ANALYTICS_ENABLED] so an opt-out saved by a build that
 * still had the switch can't linger and silently keep analytics off.
 */
class SettingsAnalyticsPrefsStore(
    private val settings: Settings,
) : AnalyticsPrefsStore {
    override fun isEnabled(): Boolean = true
    override fun setEnabled(enabled: Boolean) = settings.putBoolean(KEY_ANALYTICS_ENABLED, enabled)
}
